"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL001_Detail = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../common");
const FileDown_1 = require("../../../common/option/FileDown");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const function_1 = require("./function");
const layout_1 = require("../../base/layout");
const action_1 = require("../../menu/action");
const DSTL001_Detail_Child_1 = require("./component/DSTL001_Detail_Child");
const DSTL001ListStyled_1 = require("./component/DSTL001_List_Child/DSTL001ListStyled");
const constant_1 = require("./constant");
const DSTL001_Submit_View_1 = require("./DSTL001_Submit_View");
const getDisplaySubjectName = (subject) => subject?.replace(/^선택\s*-\s*/, '') || '';
exports.DSTL001_Detail = react_1.default.memo(({ isTest = false, test_id, isBackOffice = false, isSurvey = false, props, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isDesktop, isMobile, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const [item, setItem] = react_1.default.useState(null);
    const [statisticItem, setStatisticItem] = react_1.default.useState(null);
    // 선택과목 필터와 무관하게 시험 전체(공통+선택) 통계 — 총 문항수/합산 점수 기준
    const [allStatisticItem, setAllStatisticItem] = react_1.default.useState(null);
    // 선택과목별 실 응시 인원 (submit-status?subject_item 의 submitted). statistics.optional_counts는 +1 과다라 미사용
    const [subjectCounts, setSubjectCounts] = react_1.default.useState({});
    const [subjectId, setSubjectId] = react_1.default.useState(undefined);
    // 설문은 '설문 결과'(차트+테이블) 탭이 첫 탭 — 요구사항 순서(설문 결과 / 제출 결과).
    // ★호출부(목록 등)가 넘긴 initialBigTab 이 현재 모드의 탭 집합에 없으면(예: 설문인데
    // 'testResult' — AssignmentTable 공용 이동 코드) 기본 탭으로 보정한다. BigTabLayout 은
    // activeTabId 불일치 시 콘텐츠만 tabs[0] 로 폴백하고 active 표시가 켜지지 않는다.
    const resolveInitialBigTab = () => {
        const validTabs = isSurvey ? ['surveyResult', 'submitResult'] : ['testResult', 'gradeData'];
        const wanted = props?.initialBigTab;
        return wanted && validTabs.includes(wanted) ? wanted : validTabs[0];
    };
    const [activeBigTab, setActiveBigTab] = react_1.default.useState(resolveInitialBigTab);
    const [isInfoFolded, setIsInfoFolded] = react_1.default.useState(false);
    const [cutoffSavedRows, setCutoffSavedRows] = react_1.default.useState([]);
    const [cutoffSavedAt, setCutoffSavedAt] = react_1.default.useState('');
    const [questionStatsSavedRows, setQuestionStatsSavedRows] = react_1.default.useState([]);
    // 재진입 복원용 예상등급컷 미리보기 행 — tier-cutoff API 는 과목 구분 없이
    // (등급, 점수[범위 문자열 가능])만 주므로 업로드 raws(과목별)와 별도 상태로 둔다.
    // 미리보기는 업로드 직후 상태(cutoffSavedRows)가 있으면 그쪽을 우선한다.
    const [cutoffRestoredRows, setCutoffRestoredRows] = react_1.default.useState([]);
    const { data, refetch } = (0, server_1.useAssignmentList)({
        id: test_id,
        survey: isSurvey,
        ...(isBackOffice ? { back_office: true } : { class_id: classesId }),
    });
    const { data: statisticData, refetch: statisticRefetch } = (0, server_1.useStatistics)({
        test_id,
        subject_item: subjectId,
    });
    // 선택과목 필터 없이 시험 전체 통계 (총 문항수/합산 점수의 분모 기준)
    const { data: allStatisticData, refetch: allStatisticRefetch } = (0, server_1.useStatistics)({
        test_id,
    });
    const { data: submitStatusData, refetch: submitStatusRefetch } = (0, server_1.useSubmitStatus)({
        id: test_id,
        subject_item: subjectId,
        offset: 0,
        limit: 0,
    });
    const { data: gradeListData, refetch: gradeListRefetch } = (0, server_1.useGradesList)({
        test_id,
        member_id: '',
        orderby: ["IF(subject_item='공통',0,1)", 'subject_item'],
    });
    // 등급별 인원 분포 — 성적표(성적 데이터) 입력분 기준(미입력 시 items 빈 배열 → '-').
    // 선택과목 탭과 무관한 전체 집계라 모든 탭에 동일 노출.
    const { data: tierData, refetch: tierRefetch } = (0, server_1.useTierCount)({ test_id });
    (0, react_1.useEffect)(() => {
        if (test_id) {
            refetch();
            statisticRefetch();
            allStatisticRefetch();
            submitStatusRefetch();
            gradeListRefetch();
            tierRefetch();
        }
    }, [test_id]);
    (0, react_1.useEffect)(() => {
        if (test_id) {
            statisticRefetch();
            submitStatusRefetch();
        }
    }, [test_id, subjectId]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        if (data.found_count > 0) {
            setItem(data.items[0]);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (!item?.report_data_saved)
            return;
        setCutoffSavedAt((0, moment_1.default)(item.report_data_saved).format('YYYY-MM-DD HH:mm'));
    }, [item?.report_data_saved]);
    // 테스트가 바뀌면 성적 데이터 표 상태를 초기화 — 언마운트 없이 test_id 만 교체되는
    // 경로에서 이전 테스트의 표/저장일이 잔류하는 것 방지.
    const gradeDataRestoredForRef = react_1.default.useRef('');
    (0, react_1.useEffect)(() => {
        setCutoffSavedRows([]);
        setQuestionStatsSavedRows([]);
        setCutoffRestoredRows([]);
        setCutoffSavedAt('');
        gradeDataRestoredForRef.current = '';
    }, [test_id]);
    // ★재진입 시 성적 데이터 표 복원(2026-07-28 요구) — 예상등급컷/문항별 분석 rows 는
    // "업로드 POST 응답"에만 존재해 Detail 언마운트(페이지 이탈/새로고침)에서 소실된다.
    // 복원 소스(2026-07-29 확정, download-report-data xlsx 파싱 경로 폐기):
    //   문항별 분석 = question-stats API (subject_item 은 표시명 — 실응답 question-stats.txt 확인)
    //   예상등급컷  = tier-cutoff API (과목 구분 없이 등급별 점수, 범위 문자열 "100~74" 가능)
    // 두 소스는 독립 — 한쪽 실패가 다른 쪽 복원을 막지 않는다.
    // ★handleCutoffSaveSuccess 재사용 금지 — 저장일을 현재 시각으로 덮고 refetch/목록 갱신
    //   부수효과가 있다. cutoffSavedAt 도 건드리지 않는다(위 effect 가 서버값으로 표시 중).
    (0, react_1.useEffect)(() => {
        if (activeBigTab !== 'gradeData')
            return; // 탭을 안 여는 사용자에게 조회 낭비 방지
        if (!isTest || !(item?.report_type === 'gmk' || item?.report_type === 'yigam'))
            return;
        const saved = item?.report_data_saved;
        const savedMoment = saved ? (0, moment_1.default)(saved) : null;
        if (!savedMoment || !savedMoment.isValid() || savedMoment.year() <= 1)
            return; // zero-date=저장 이력 없음
        if (cutoffSavedRows.length > 0 || questionStatsSavedRows.length > 0)
            return; // 업로드 직후 상태 우선
        if (gradeDataRestoredForRef.current === test_id)
            return; // 테스트당 1회
        gradeDataRestoredForRef.current = test_id;
        let cancelled = false;
        (async () => {
            const [statsRes, cutoffRes] = await Promise.allSettled([
                (0, server_1.getQuestionStats)(test_id),
                (0, server_1.getTierCutoff)(test_id),
            ]);
            if (cancelled)
                return;
            const questionRows = statsRes.status === 'fulfilled' ? (0, function_1.mapQuestionStatsToRows)(statsRes.value) : [];
            if (statsRes.status === 'rejected') {
                // 복원 실패는 기존('업로드 전') 화면 유지 — 에러 표시로 업로드 흐름을 막지 않는다
                console.error('[성적데이터 복원] question-stats 조회 실패:', statsRes.reason);
            }
            // tier-cutoff 는 과목 구분이 없어 미리보기 그룹명은 테스트 과목명으로 표시.
            // item.subject 는 서버 원문 코드('korean' 등) — 기존 표기 관례(:336)와 동일하게
            // assignment.* 번역 키로 한글화하고, 키가 없으면 원문 폴백.
            const subjectRaw = getDisplaySubjectName(item?.subject);
            const cutoffSubject = subjectRaw
                ? t(`assignment.${subjectRaw}`, { defaultValue: subjectRaw })
                : '전체';
            const cutoffRows = cutoffRes.status === 'fulfilled'
                ? (cutoffRes.value?.result?.items || [])
                    .filter((i) => i && Number.isFinite(Number(i.tier)) && Number(i.tier) > 0)
                    .map((i) => ({
                    subject: cutoffSubject,
                    tier: Number(i.tier),
                    score: i.score ?? '-',
                }))
                    .sort((a, b) => a.tier - b.tier)
                : [];
            if (cutoffRes.status === 'rejected') {
                console.error('[성적데이터 복원] tier-cutoff 조회 실패:', cutoffRes.reason);
            }
            if (cancelled)
                return;
            // 복원 fetch 중 사용자가 새로 업로드했을 수 있음 — 신규 업로드 우선(함수형 가드)
            if (questionRows.length)
                setQuestionStatsSavedRows(prev => (prev.length ? prev : questionRows));
            if (cutoffRows.length)
                setCutoffRestoredRows(prev => (prev.length ? prev : cutoffRows));
        })();
        return () => {
            cancelled = true;
        };
        // cutoffSavedRows/questionStatsSavedRows 는 의도적으로 deps 제외(ref·길이 가드가 재실행 제어)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeBigTab, isTest, item?.report_type, item?.report_data_saved, test_id]);
    (0, react_1.useEffect)(() => {
        if (!statisticData)
            return;
        setStatisticItem(statisticData);
    }, [statisticData]);
    (0, react_1.useEffect)(() => {
        if (!allStatisticData)
            return;
        setAllStatisticItem(allStatisticData);
    }, [allStatisticData]);
    // 선택과목별 실 응시 인원 집계: 과목 필터 submit-status 의 submitted 사용
    // (statistics.optional_counts 는 서버에서 +1 과다로 내려와 부정확)
    (0, react_1.useEffect)(() => {
        const tabs = Array.from(new Set((gradeListData?.items || [])
            .map((g) => g.subject_item)
            .filter((s) => s && s !== '공통')));
        if (!test_id || tabs.length === 0) {
            setSubjectCounts({});
            return;
        }
        let cancelled = false;
        Promise.all(tabs.map(async (subj) => {
            try {
                const res = await (0, server_1.getSubmitStatus)({
                    id: test_id,
                    queryString: `subject_item=${encodeURIComponent(subj)}&offset=0&limit=0`,
                });
                return [subj, Number(res?.result?.submitted) || 0];
            }
            catch {
                return [subj, 0];
            }
        })).then(entries => {
            if (!cancelled)
                setSubjectCounts(Object.fromEntries(entries));
        });
        return () => {
            cancelled = true;
        };
    }, [test_id, gradeListData]);
    (0, react_1.useEffect)(() => {
        if (item && !isDesktop) {
            if (isMobile) {
                const mobileStatusText = item.status === 'closed'
                    ? t('assignment.closed')
                    : item.status === 'open'
                        ? t('assignment.open')
                        : item.status === 'created'
                            ? t('assignment.created')
                            : item.status;
                dispatch((0, action_1.changeMobileMenuName)(react_1.default.createElement("span", { className: "mobile-nav-title-wrap" },
                    mobileStatusText && (react_1.default.createElement("span", { className: "mobile-nav-status-chip" }, mobileStatusText)),
                    react_1.default.createElement("span", { className: "mobile-nav-title-text overText" }, item.title))));
            }
            else {
                dispatch((0, action_1.changeMobileMenuName)(item.title));
            }
        }
    }, [item, isDesktop, isMobile]);
    (0, react_1.useEffect)(() => {
        const rememberedSubjectId = localStorage.getItem('rememberSubjectId');
        if (rememberedSubjectId) {
            setSubjectId(JSON.parse(rememberedSubjectId));
            localStorage.removeItem('rememberSubjectId');
        }
    }, []);
    (0, react_1.useEffect)(() => {
        setActiveBigTab(resolveInitialBigTab());
    }, [props?.initialBigTab, test_id, isSurvey]);
    const handleCutoffSaveSuccess = react_1.default.useCallback((raws) => {
        const now = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        const savedAt = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
        const firstRow = raws[0];
        // Detect type by header row column name; fall back to max column count
        // 수능예상점수 header: [과목코드, 원점수, ...] (≤5 cols)
        // 문항별 분석 header:  [과목코드, 문항번호, ...] (up to 9 cols)
        const secondCol = Array.isArray(firstRow) ? String(firstRow[1] ?? '').trim() : '';
        const isCutoff = secondCol === '원점수'
            || (secondCol !== '문항번호' && Math.max(...raws.map(r => r.length)) <= 5);
        if (isCutoff) {
            setCutoffSavedRows(raws);
            setCutoffSavedAt(savedAt);
        }
        else {
            setQuestionStatsSavedRows(raws);
        }
        refetch();
        // 성적 데이터 업로드 후 목록(테스트/과제)의 '성적표' 상태(등록하기→등록 완료)가
        // 바로 갱신되도록 목록 refetch 를 요청한다. (목록이 마운트 상태로 남아 있어도 stale 방지)
        APP.eventManager.publish(constant_1.REFRESH_ASSIGNMENT_LIST);
    }, [refetch]);
    const previousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: undefined,
            id: undefined,
        });
    };
    if (!item)
        return null;
    const statusText = item.status === 'closed'
        ? t('assignment.closed')
        : item.status === 'open'
            ? t('assignment.open')
            : item.status === 'created'
                ? t('assignment.created')
                : item.status;
    const isOmrType = item.type === 'OMR (기본형)' || item.type === 'OMR (자유형)';
    const questionType = item.type === 'OMR (기본형)' || item.type === 'OMR (자유형)'
        ? `${item.type}${item.subject ? ` - ${t(`assignment.${getDisplaySubjectName(item.subject)}`, { defaultValue: getDisplaySubjectName(item.subject) })}` : ''}`
        : item.type;
    const progressDateText = `${(0, moment_1.default)(item.startline).format('YYYY-MM-DD HH:mm')} ~ ${(0, moment_1.default)(item.deadline).format('YYYY-MM-DD HH:mm')}`;
    const attachments = item.attachments || [];
    const isAttachmentDownloadOpen = item.status === 'open';
    const registrant = item.author_name || '-';
    const gradeItems = gradeListData?.items || [];
    const groupedSubjectItems = gradeItems.reduce((acc, current) => {
        if (!current.subject_item || current.subject_item === '공통')
            return acc;
        acc[current.subject_item] = (acc[current.subject_item] || 0) + 1;
        return acc;
    }, {});
    const subjectTabs = Object.keys(groupedSubjectItems);
    // 선택과목별 응시 인원: grades는 과목당 1행(인원수 아님)이라, 과목 필터 submit-status로 집계한 subjectCounts 사용
    const getSubjectCount = (subject) => subjectCounts[subject] ?? groupedSubjectItems[subject] ?? 0;
    const shouldShowSubjectTabs = subjectTabs.length > 0;
    // 정책: '선택과목 응시 분포'는 선택과목 체계가 있는 수학/국어일 때만 노출한다.
    // (영어는 듣기/읽기가 택1이 아니라 전원 응시라 분포 개념이 성립하지 않는 등, 그 외 과목은 숨김.
    //  응시현황·평균·과목필터는 과목과 무관하게 유지)
    const isDistributionSubject = item?.subject === 'math' || item?.subject === 'korean';
    const shouldShowSubjectDistribution = !subjectId && shouldShowSubjectTabs && isDistributionSubject;
    const subjectPieData = subjectTabs.map((subject, index) => ({
        id: subject,
        label: getDisplaySubjectName(subject),
        value: getSubjectCount(subject),
        color: ['#4ec3cc', '#c3d8a9', '#8fc4cc', '#76b5c0'][index % 4],
    }));
    const submitted = submitStatusData?.submitted ?? statisticItem?.submitted ?? 0;
    // 대상 인원(total_count) 우선. not_submitted가 서버에서 null로 와도 (대상-제출)로 계산해
    // 미제출 0 → 100% 오표기 방지.
    const totalTarget = submitStatusData?.total_count ??
        submitted + (submitStatusData?.not_submitted ?? statisticItem?.not_submitted ?? 0);
    const notSubmitted = submitStatusData?.not_submitted ??
        statisticItem?.not_submitted ??
        Math.max(0, totalTarget - submitted);
    const selectedSubjectCount = subjectId
        ? submitted
        : subjectTabs.reduce((sum, s) => sum + getSubjectCount(s), 0);
    const attendancePieData = [
        { id: 'submitted', label: isTest ? t('assignment.takenPerson') : t('assignment.submitPerson'), value: submitted, color: '#4ec3cc' },
        { id: 'notSubmitted', label: isTest ? t('assignment.noTakenPerson') : t('assignment.noSubmitPerson'), value: notSubmitted, color: '#d8dadd' },
    ];
    // 선택과목 필터 시 해당 과목의 /statistics 응답으로 평균·총 문항수 표시.
    // (필터 없으면 statisticItem 이 곧 전체 통계) — 평균이 항상 전체값으로 고정되던 버그 수정.
    const baseStat = statisticItem ?? allStatisticItem;
    const allAverage = baseStat?.average?.['100%'] || { score: -1, corrects: -1 };
    const questionCount = baseStat?.question_count || 0;
    // 서버는 존재하는 등급만 내려준다({tier, count}) — 1~9 등급으로 펼치고 같은 등급은 합산.
    // ★훅(useMemo) 금지: 이 지점은 `if (!item) return null`(조기 return) 아래라 훅을 두면
    // item 로드 시 훅 개수가 달라져 React #310 으로 크래시한다(실사고). 항목이 최대 9개라
    // 매 렌더 일반 계산으로 충분.
    const tierCounts = {};
    (tierData?.items || []).forEach((it) => {
        const tier = Number(it?.tier);
        if (!Number.isFinite(tier))
            return;
        tierCounts[tier] = (tierCounts[tier] || 0) + (Number(it?.count) || 0);
    });
    const hasTierData = Object.keys(tierCounts).length > 0;
    const renderInfoTitle = (react_1.default.createElement(DSTL001_Detail_Child_1.InfoTitle, { key: "infoTitle", isTeacher: true, title: item.title, statusText: statusText, test_id: test_id, isTest: isTest, isSurvey: isSurvey, previousPage: previousPage }));
    const renderSubmissionStatusTable = (react_1.default.createElement(DSTL001_Detail_Child_1.SubmissionStatusTable, { key: "submissionStatus", test_id: test_id, isTest: isTest, isSurvey: isSurvey, type: item?.type, hasReport: item?.has_report, gradeReport: item?.grade_report, reportSubjectLabel: getDisplaySubjectName(subjectId || item?.subject), reportTestDate: item?.deadline, reportType: item?.report_type, subjectId: subjectId, allQuestionCount: questionCount, isDetail: true, reportName: item?.report_name }));
    const renderAverageSummaryCards = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "summary-card" },
            react_1.default.createElement("div", { className: "card-title" }, t('assignment.allTakerAverage')),
            react_1.default.createElement("div", { className: "avg-row" },
                react_1.default.createElement("div", { className: "avg-item" },
                    react_1.default.createElement("div", { className: "metric-label" }, t('assignment.averageCorrectCount')),
                    react_1.default.createElement("div", { className: "avg-value-group" },
                        react_1.default.createElement("div", { className: "avg-value" }, allAverage.corrects === -1 ? '-' : allAverage.corrects),
                        react_1.default.createElement("div", { className: "metric-label" },
                            "/",
                            questionCount))),
                react_1.default.createElement("div", { className: "avg-item" },
                    react_1.default.createElement("div", { className: "metric-label" }, t('assignment.averageScore')),
                    react_1.default.createElement("div", { className: "avg-value-group" },
                        react_1.default.createElement("div", { className: "avg-value" }, allAverage.score === -1 ? '-' : allAverage.score),
                        react_1.default.createElement("div", { className: "metric-label" }, t('assignment.point')))))),
        react_1.default.createElement("div", { className: "summary-card" },
            react_1.default.createElement("div", { className: "card-title" }, t('assignment.tierDistribution')),
            react_1.default.createElement("div", { className: "tier-row" }, [
                ...[1, 2, 3, 4].map(tier => ({ key: `${tier}`, label: `${tier}등급`, value: tierCounts[tier] || 0 })),
                {
                    key: 'under5',
                    label: '5등급 이하',
                    value: Object.entries(tierCounts).reduce((sum, [tier, count]) => (Number(tier) >= 5 ? sum + count : sum), 0),
                },
            ].map(bucket => (react_1.default.createElement("div", { key: bucket.key, className: "tier-item" },
                react_1.default.createElement("span", { className: "tier-label" }, bucket.label),
                react_1.default.createElement("span", { className: "tier-value" }, hasTierData ? `${bucket.value}명` : '-'))))))));
    const renderAttendanceSummaryCard = (react_1.default.createElement("div", { className: "summary-card" },
        react_1.default.createElement("div", { className: "card-title" }, isTest ? t('assignment.attendanceOverview') : t('assignment.submitOverview')),
        react_1.default.createElement("div", { className: "chart-metric-wrap" },
            react_1.default.createElement("div", { className: "pie-wrap" },
                react_1.default.createElement(common_1.SepratedPieChart, { data: attendancePieData, unit: t('assignment.memberUnit'), size: isMobile ? 112 : 122 })),
            react_1.default.createElement("div", { className: "metric-list" },
                react_1.default.createElement("div", { className: "metric-item" },
                    react_1.default.createElement("div", { className: "metric-label" }, t('assignment.totalTargetCount')),
                    react_1.default.createElement("div", { className: "metric-value" }, t('assignment.person', { count: totalTarget }))),
                react_1.default.createElement("div", { className: "metric-item" },
                    react_1.default.createElement("div", { className: "metric-label" }, t('assignment.submitPerson')),
                    react_1.default.createElement("div", { className: "metric-value" }, t('assignment.person', { count: submitted }))),
                react_1.default.createElement("div", { className: "metric-item" },
                    react_1.default.createElement("div", { className: "metric-label" }, t('assignment.noSubmitPerson')),
                    react_1.default.createElement("div", { className: "metric-value" }, t('assignment.person', { count: notSubmitted })))))));
    const renderTotalResults = (react_1.default.createElement("div", { className: "tab-content-wrap" },
        react_1.default.createElement("div", { className: "summary-title-row" },
            react_1.default.createElement("div", { className: "summary-title" }, isTest
                ? t('assignment.testResultSummary')
                : isSurvey
                    ? t('assignment.surveyResultSummary')
                    : t('assignment.taskResultSummary'))),
        isOmrType ? (shouldShowSubjectDistribution ? (react_1.default.createElement("div", { className: "summary-grid" },
            renderAttendanceSummaryCard,
            react_1.default.createElement("div", { className: "summary-card" },
                react_1.default.createElement("div", { className: "card-title" }, t('assignment.subjectAttendanceDistribution')),
                react_1.default.createElement("div", { className: "chart-metric-wrap" },
                    react_1.default.createElement("div", { className: "pie-wrap" },
                        react_1.default.createElement(common_1.SepratedPieChart, { data: subjectPieData, unit: t('assignment.memberUnit'), size: isMobile ? 112 : 122 })),
                    react_1.default.createElement("div", { className: "metric-list" }, subjectTabs.map(subject => (react_1.default.createElement("div", { key: subject, className: "metric-item" },
                        react_1.default.createElement("div", { className: "metric-label" }, getDisplaySubjectName(subject)),
                        react_1.default.createElement("div", { className: "metric-value" }, t('assignment.person', { count: getSubjectCount(subject) })))))))),
            renderAverageSummaryCards)) : (react_1.default.createElement("div", { className: "summary-grid" },
            renderAttendanceSummaryCard,
            react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 14 } }, renderAverageSummaryCards)))) : (react_1.default.createElement("div", { className: "summary-grid" }, renderAttendanceSummaryCard)),
        react_1.default.createElement("div", { className: "summary-table" }, renderSubmissionStatusTable)));
    const renderSubjectResults = (react_1.default.createElement("div", { className: "tab-content-wrap" },
        react_1.default.createElement("div", { className: "summary-title-row" },
            react_1.default.createElement("div", { className: "summary-title" }, isTest
                ? t('assignment.testResultSummary')
                : isSurvey
                    ? t('assignment.surveyResultSummary')
                    : t('assignment.taskResultSummary')),
            react_1.default.createElement("div", { className: "subject-member-count" },
                t('assignment.examTakerCount'),
                "\u00A0\u00A0",
                t('assignment.person', { count: selectedSubjectCount }))),
        isOmrType ? (react_1.default.createElement("div", { className: "summary-grid" }, renderAverageSummaryCards)) : (react_1.default.createElement("div", { className: "summary-grid" }, renderAttendanceSummaryCard)),
        react_1.default.createElement("div", { className: "summary-table" }, renderSubmissionStatusTable)));
    const resultTabContent = (react_1.default.createElement(DSTL001ListStyled_1.ResultDetailStyled, { "$isMobile": isMobile, "$isDesktop": isDesktop, "$isTablet": isTablet },
        react_1.default.createElement("div", { className: "result-card" },
            shouldShowSubjectTabs && (react_1.default.createElement(layout_1.TabLayout, { activeTabId: subjectId || 'all', onTabChange: tabId => setSubjectId(tabId === 'all' ? undefined : tabId), tabs: [
                    { id: 'all', title: t('common.all'), content: renderTotalResults },
                    ...subjectTabs.map(subject => ({
                        id: subject,
                        title: getDisplaySubjectName(subject),
                        content: renderSubjectResults,
                    })),
                ], equalButtonWidth: true, equalButtonMinWidth: isMobile ? 70 : 124, buttonSize: isMobile ? 108 : 138 })),
            shouldShowSubjectTabs ? null : renderTotalResults)));
    // 설문 결과 탭: Live 테스트 결과보기와 동일한 '차트+테이블'(문항별 응답 통계) 노출.
    // DSTL001_Submit_View 를 member 없이 재사용 — 내부에서 SurveyContainer(member_id='')가
    // 설문 빈도(useSurveyFrequency) 기반 SurveyResultLayout(차트+페이지네이션 테이블)을 렌더하고,
    // 차트/테이블 CSS(DSTL001ViewStyled)도 함께 가져와 Live 결과 화면과 동일하게 보인다.
    const surveyResultTabContent = (react_1.default.createElement(DSTL001ListStyled_1.ResultDetailStyled, { "$isMobile": isMobile, "$isDesktop": isDesktop, "$isTablet": isTablet },
        react_1.default.createElement("div", { className: "result-card" },
            react_1.default.createElement(DSTL001_Submit_View_1.DSTL001_Submit_View, { test_id: test_id, isSurvey: true }))));
    return (react_1.default.createElement(DSTL001_Detail_Child_1.DSTL001DetailStyled, { className: "wrapper-padding", "$isTablet": isTablet, "$isMobile": isMobile },
        isDesktop && renderInfoTitle,
        react_1.default.createElement(DSTL001ListStyled_1.TestDetailStyled, { "$isMobile": isMobile, "$isDesktop": isDesktop },
            react_1.default.createElement("div", { className: "test-info-panel" },
                react_1.default.createElement("div", { className: "test-info-header" },
                    react_1.default.createElement("div", { className: "test-info-title" }, isTest
                        ? t('assignment.testInfo')
                        : isSurvey
                            ? t('assignment.surveyInfo')
                            : t('assignment.taskInfo')),
                    react_1.default.createElement(common_1.Button, { className: `test-info-toggle ${isInfoFolded ? 'folded' : 'expanded'}`, option: {
                            buttonBeforeIcon: {
                                show: true,
                                name: 'arrow',
                                size: 22,
                                className: 'test-info-toggle-icon',
                            },
                        }, onClick: () => setIsInfoFolded(prev => !prev) })),
                !isInfoFolded && (react_1.default.createElement("div", { className: "test-info-body" },
                    react_1.default.createElement("div", { className: "info-field" },
                        react_1.default.createElement("div", { className: "info-label" }, t('table.progress_period')),
                        react_1.default.createElement("div", { className: "info-value" }, progressDateText)),
                    react_1.default.createElement("div", { className: "info-field" },
                        react_1.default.createElement("div", { className: "info-label" }, t('assignment.attachFile')),
                        react_1.default.createElement("div", { className: "info-links" },
                            react_1.default.createElement(FileDown_1.FileDown, { files: attachments, isOpen: isAttachmentDownloadOpen, allowAlways: true }))),
                    !isSurvey && (react_1.default.createElement("div", { className: "info-field" },
                        react_1.default.createElement("div", { className: "info-label" }, t('assignment.questionType')),
                        react_1.default.createElement("div", { className: "info-value" }, questionType))),
                    react_1.default.createElement("div", { className: "info-field" },
                        react_1.default.createElement("div", { className: "info-label" }, t('assignment.register')),
                        react_1.default.createElement("div", { className: "info-value" }, registrant)))))),
        isTest && (item?.report_type === 'gmk' || item?.report_type === 'yigam') ? (react_1.default.createElement(layout_1.BigTabLayout, { activeTabId: activeBigTab, onTabChange: setActiveBigTab, tabs: [
                {
                    id: 'testResult',
                    title: t('assignment.testResultTab'),
                    content: resultTabContent,
                },
                {
                    id: 'gradeData',
                    title: t('assignment.gradeDataManage'),
                    content: react_1.default.createElement(DSTL001_Detail_Child_1.GradeDataManager, { testId: test_id, savedRows: cutoffSavedRows, savedAt: cutoffSavedAt, questionStatsSavedRows: questionStatsSavedRows, restoredCutoff: cutoffRestoredRows, onSaveSuccess: handleCutoffSaveSuccess, reportType: item?.report_type, reportName: item?.report_name, gradeReport: item?.grade_report }),
                },
            ] })) : isSurvey ? (
        // 설문: '설문 결과'(차트+테이블) / '제출 결과'(기존 요약+제출 현황) 두 탭
        react_1.default.createElement(layout_1.BigTabLayout, { activeTabId: activeBigTab, onTabChange: setActiveBigTab, tabs: [
                {
                    id: 'surveyResult',
                    title: t('assignment.surveyResultTab'),
                    content: surveyResultTabContent,
                },
                {
                    id: 'submitResult',
                    title: t('assignment.submitResultTab'),
                    content: resultTabContent,
                },
            ] })) : resultTabContent));
});
